<template>
	<div class="container page">
		<van-nav-bar :title="lottery.name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			 <template #right>
			   <div class="right" @click="$router.push({ path: '/GameRecord' })">
				   <van-icon name="balance-list-o" color="#fff" />
			   </div>
			 </template>
		</van-nav-bar>

		<div class="lottery">
			<div class="bix">
				<div class="record">
					<div class="info_c_h">
						<div>{{ $t('page.lottery.lotterynow') }}</div>
						<div class="p-tb-10">
							<span class="p-r-10">{{ lottery.next_expect }}</span>
							<span>{{ $t('page.lottery.lotterying') }}</span>
						</div>
						<div>
							<div class="next-number">
								<van-count-down :time="time" @finish="check()" />
							</div>
						</div>
					</div>
					<div class="info_c_b">
						<div>
							<span >{{ lottery.now_expect }}</span> 
							<span style="margin: 0 5px;" :class="'bg_'+elementclas(sum)"> {{this.size}} </span>
							<span :class="'bg_'+parityclas(sum)" > {{this.double}} </span>
						</div>
						<div @click="active ? active = false : active = true">
							<span>{{ $t('page.lottery.lottery_log') }}</span>
							<van-icon name="arrow-down" :class="{ up: active,down:!active }"
								 />
						</div>
					</div>
				</div>
				<div class="options-bar">
					<div class="put_tit_r">{{ $t('page.lottery.lottery_sec') }}</div>
					<div class="game">
						<div class="sumValueTwoSides">
							<div class="rectangle large"  
							v-for="(v,key) in choose_v2" :key="key" :class="{active:choose[v.type]}"
							@click="choosePlay(v.type,v.name);" >
								<div class="c_u_item " :class="v.class">
									<van-image width="80" height="80" class="game_item_img" :src="v.ico">
									    <template v-slot:loading>
									        <van-loading type="circular" />
									    </template>
									</van-image>
									<div class="text_ks">
										{{ v.namelang }}
									</div>
								</div>
							</div>
						
						</div>
					</div>
				</div>
			</div>
		</div>

		
		<div class="history_popup"></div>
		
		<div class="wrapper">
			
			<div class="bottom-bar">
				<div class="bar">
					<div class="left">
						<div class="item" @click="shopping ? shopping = false : shopping = true ">
							<van-icon name="cart-o" class="jixuanico" />
						</div>
						<div class="line"></div>
					</div>
					<div class="mid">
						<span class="text">{{ $t('page.lottery.availableBalance') }}</span>
						<span class="text num">{{ this.userInfo.money }}</span>
						<span class="text"> {{ $t('page.lottery.currency') }}</span>
					</div>
					<div class="right" @click="jiesuan()">
						{{ $t('page.lottery.submit') }}
					</div>
				</div>
				<div class="wrapper" :class="{active:shopping}">
					<div class="item">
						<span class="label">{{ $t('page.lottery.currentChoice') }}</span>
						<div class="bet-number">{{ this.shopchoose}}</div>
						<van-icon name="arrow-down" :class="{ up: !shopping,down:shopping }"
							@click="shopping ? shopping = false : shopping = true" />
					</div>
					<div class="item">
						<span class="label">{{ $t('page.lottery.betAmount') }}</span>
						<div class="amount-wrapper">
							<van-field v-model="money"  type="digit" :placeholder="$t('page.lottery.enterAmount')" />
							<span class="label"></span>
						</div>
					</div>
					<div class="item">
						<div class="part">
							<span>{{ $t('page.lottery.selected') }}</span>
							<span class="number">{{this.formData.length}}</span>
							<span></span>
						</div>
						<div class="part">
							<span>{{ $t('page.lottery.total') }}</span>
							<span class="number">{{this.formData.length * this.money}}</span>
							<span>{{ $t('page.lottery.currency') }}</span>
						</div>

					</div>
				</div>
			</div>
			
			<van-popup v-model="jiesuanpage" get-container="body">
				<div class="confirm-order-modal">
					<div class="head van-hairline--bottom">
						<p class="text">{{ $t('page.lottery.taskOrder') }}</p>
					</div>
					<ul class="list">
						<li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
							<div class="main">
								<p class="bet-name">{{ getchoosename(v.name) }}</p>
							</div>
							<van-icon @click="clearChooes(v.type)" name="close" />
						</li>
					</ul>
					<div class="sub-bar">
						<van-button class="item cancel-btn" type="default"
							@click="allClear()">{{ $t('page.lottery.clearOrder') }}</van-button>
						<van-button class="item sub-btn" type="default"
							@click="doSub">{{ $t('page.lottery.confirmSubmit') }}</van-button>
					</div>
				</div>
			</van-popup>
			<van-popup v-model="active" position="top" :style="{ height: '80%' }">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<div class="wrapper">
						<div class="item">
							<div class="left font-weight">{{ $t('page.lottery.periodNumber') }}</div>
							<div class="right font-weight">{{ $t('page.lottery.resultNumber') }}</div>
						</div>
						<div class="item" v-for="(v,key) in lottery_list" :key="key">
							<div class="left font-weight">{{v.expect}}</div>
							<div class="right font-weight">
								<div class="kuaisan-ball left">
									<div class="opennum">
										{{v.opencode[0]}}
									</div >
									<div class="opennum">
										{{v.opencode[1]}}
									</div>
									<div class="opennum">
										{{v.opencode[2]}}
									</div>
									<span
										class="res-des middle">{{v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span>
									<span style="margin: 0 5px;" :class="'bg_'+elementclas(v.opencode[0] + v.opencode[1] + v.opencode[2])"> {{ elementText(v.opencode[0] + v.opencode[1] + v.opencode[2]) }} </span>
									<span :class="'bg_'+parityclas(v.opencode[0] + v.opencode[1] + v.opencode[2])" > {{ parityText(v.opencode[0] + v.opencode[1] + v.opencode[2]) }} </span>
								</div>
							</div>
						</div>
					</div>
				</van-pull-refresh>
			</van-popup>
		
		</div>
	
	</div>
</template>

<script>
	var time;
	var count = 0;
	export default {
		data() {
			return {
				jiesuanpage: false,
				choose: {
					"bi": false,
					"sm": false,
					"si": false,
					"do": false,
					"3": false,
					"4": false,
					"5": false,
					"6": false,
					"7": false,
					"8": false,
					"9": false,
					"10": false,
					"11": false,
					"12": false,
					"13": false,
					"14": false,
					"15": false,
					"16": false,
					"17": false,
					"18": false,
					// "bi": false,
					// "sm": false,
					// "si": false,
					// "do": false,
				},
				choose_v2:[],
				playgame: false,
				shopping: false,
				isLoading: false,
				play: {},
				lottery_peilv_list: {},
				lottery_list: {},
				active: false,
				userInfo: {},
				lottery: {},
				shanzi_1: "0",
				shanzi_2: "0",
				shanzi_3: "0",
				sum: 0,
				size: "",
				double: "",
				time: 0,
				shopchoose: this.$t('page.lottery.notSelected'),
				gameitem: "",
				formData: [],
				money: 0,
			};
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
				this.getLotteryInfo();
				this.getLotteryList();
		
			}
			this.choose_v2 = [
				{
					'name':'bi',
					'type':'bi',
					'status':true,
					'proportion':1.98,
					'namelang':this.$t('page.lottery.lottery_da'),
					'ico':'/img/huojian.gif',
					'class':'da'
				},
				{
					'name':'sm',
					'type':'sm',
					'status':true,
					'proportion':1.98,
					'namelang':this.$t('page.lottery.lottery_xiao'),
					'ico':'/img/love.gif',
					'class':'xiao'
				},
				{
					'name':'si',
					'type':'si',
					'status':true,
					'proportion':1.98,
					'namelang':this.$t('page.lottery.lottery_dan'),
					'ico':'/img/youting.gif',
					'class':'dan'
				},
				{
					'name':'do',
					'type':'do',
					'status':true,
					'proportion':1.98,
					'namelang':this.$t('page.lottery.lottery_shuang'),
					'ico':'/img/meigui.gif',
					'class':'shuang'
				},
			]
		},
		
		methods: {
			back() {
				return window.history.back();
			},
			elementText(sum) {
				return sum >= 11 && sum <= 18 ? this.$t('page.lottery.lottery_da') : this.$t('page.lottery.lottery_xiao')
			},
			parityText(sum) {
				return sum % 2 === 0 ? this.$t('page.lottery.lottery_shuang') : this.$t('page.lottery.lottery_dan')
			},
			
			elementclas(sum) {
				return sum >= 11 && sum <= 18 ? 'da' : 'xiao'
			},
			parityclas(sum) {
				return sum % 2 === 0 ? 'shuang' : 'dan'
			},
			getchoosename(str){
				let hasExist = this.choose_v2.find(item => item.name === str );
				if(hasExist){
					return hasExist.namelang;
				}else{
					return str
				}
			},
			doSub() {
				if (this.money === "0") {
					this.$toast(this.$t('page.lottery.invalidAmount'));
					return false;
				}
				if (this.formData.length === 0) {
					this.$toast(this.$t('page.lottery.selectNumber'));
					return false;
				} else if (this.money === "") {
					this.$toast(this.$t('page.lottery.enterAmountWarn'));
					return false;
				} else {
					if (this.userInfo.money - (this.money * this.formData.length) < 0) {
						this.$toast(this.$t('page.lottery.insufficientBalance'));
						return false;
					} else {
						this.$http({
							method: 'post',
							data: {
								item: this.gameitem,
								money: this.money,
								lid: this.lottery.id,
								mid: this.userInfo.id,
								expect: this.lottery.now_expect
							},
							url: 'game_place_order'
						}).then(res => {
							if (res.code === 200) {
								this.$toast(res.msg);
								this.allClear();
								this.getUserInfo();
							} else if (res.code === 401) {
								this.$toast(res.msg);
							}
						})
						return true;
					}
				}
			},
			allClear() {
				for (var i = 0; i < this.formData.length; i++) {
					this.choose[this.formData[i]['type']] = false;
				}
				this.formData.length = 0;
				this.money = "";
				this.shopchoose = this.$t('page.lottery.notSelected');
				this.gameitem = "";
				this.shopping = false;
				this.jiesuanpage = false;
			},
			jiesuan() {
				if (this.formData.length === 0) {
					this.$toast(this.$t('page.lottery.selectNumber'));
					return false;
				} else if (this.money === "") {
					this.$toast(this.$t('page.lottery.enterAmountWarn'));
					return false;
				} else {
					this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
				}

			},
			clearChooes(type) {
				for (var i = 0; i < this.formData.length; i++) {
					if (type === this.formData[i]['type']) {
						this.formData.splice(i, 1)
						this.choose[type] = false;
					}
				}
				if (this.formData.length >= 1) {
					for (var j = 0; j < this.formData.length; j++) {
						if (j === 0) {
							this.shopchoose = this.getchoosename(this.formData[j]['name']);
							this.gameitem = this.formData[j]['type'];
						} else {
							this.shopchoose += "," + this.getchoosename(this.formData[j]['name']);
							this.gameitem += "," + this.formData[j]['type'];
						}
					}
				} else {
					this.shopchoose = this.$t('page.lottery.notSelected');
					this.gameitem = "";
					this.shopping = false;
				}
				if (this.formData.length === 0) {
					this.jiesuanpage = false;
				}
			},
			choosePlay(type, name) {
				if (this.choose[type] === true) {
					this.choose[type] = false;
					for (var i = 0; i < this.formData.length; i++) {
						if (type === this.formData[i]['type']) {
							this.formData.splice(i, 1)
						}
					}
				} else if (this.choose[type] === false) {
					
					this.formData.push({
						'name': name,
						'type': type
					})
	
					this.choose[type] = true;
									
				}
				if (this.formData.length === 1) {
					this.shopping = true;
				}
				
				if (this.formData.length >= 1) {
					for (var j = 0; j < this.formData.length; j++) {
						if (j === 0) {
							this.shopchoose = this.getchoosename(this.formData[j]['name']);
							this.gameitem = this.formData[j]['type'];
						} else {
							this.shopchoose += "," + this.getchoosename(this.formData[j]['name']);
							this.gameitem += "," + this.formData[j]['type'];
						}
					}
				} else {
					this.shopchoose = this.$t('page.lottery.notSelected');
					this.gameitem = "";
					this.shopping = false;
				}
			},
			check() {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					time = window.setInterval(() => {
						setTimeout(() => {
							this.getUserInfo();
							this.getLotteryInfo();
							this.getLotteryList();
							count++;
							if (count > 5) {
								clearInterval(time);
								count = 0;
							}
						}, 0)
					}, 3000)
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t('page.lottery.refreshSuccess'));
					this.getLotteryList();
					this.isLoading = false;
				}, 200);
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getLotteryPeilv() {
				this.$http({
					method: 'get',
					data: {
						id: this.$route.query.id
					},
					url: 'lottery_get_peilv'
				}).then(res => {
					if (res.code === 200) {
						this.lottery_peilv_list = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getLotteryList() {
				this.$http({
					method: 'get',
					data: {
						key: this.$route.query.key
					},
					url: 'lottery_get_one_list'
				}).then(res => {
					if (res.code === 200) {
						this.lottery_list = res.data;
						this.getLotteryPeilv();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getLotteryInfo() {
				this.$http({
					method: 'get',
					data: {
						key: this.$route.query.key
					},
					url: 'lottery_get_info'
				}).then(res => {
					if (res.code === 200) {
						if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
							this.$toast(this.$t('page.lottery.contactAdminForTask'));
							this.$router.push({
								path: '/Home'
							})
							return false;
						}
						this.lottery = res.data;
						this.time = res.data.second * 1000;

						if (this.time / 1000 === 59) {
							this.$toast(this.$t('page.lottery.lotteryResultPeriod', {
								period: this.lottery.now_expect
							}));
						}
						if(res.data.opencode){
							this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
							this.size = this.elementText(this.sum);
							this.double = this.parityText(this.sum);
						}
						
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})

			}
		},
		
		destroyed() {
			clearInterval(time);
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar .right {
		padding-left: 8px;
		padding-right: 8px;
		color: #fff;
		font-size: 28px;
		border-radius: 10px;
		border: 2px solid #fff;
		line-height: 60px;
	}

	.record .period {
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.record .period .cover {
		width: 60px;
		height: 60px;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.record .period .period-number {
		flex: 1;
		margin-left: 20px;
		margin-right: 10px;
		height: 50px;
		line-height: 50px;
		font-size: 35px;
		font-weight: 700;
		color: #000;
	}

	.van-count-down {
		color: #fff;
		font-size: 30px;
		float: right;
		border: 1px solid #ccc;
		padding: 15px 5px;
		border-radius: 10px;

	}

	.linear-gradient {
		width: 100%;
		height: 2px;
	}

	.record .recent {
		display: flex;
		align-items: center;
		height: 110px;
	}

	.kuaisan-ball .left {
		justify-content: flex-start;
	}

	.kuaisan-ball {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.kuaisan-ball .res-img {
		width: 70px;
		height: 70px;
		margin-right: 30px;
	}

	.kuaisan-ball .res-des {
		font-weight: 700;
		text-align: center;
		color: #000;
	}

	.kuaisan-ball .res-des.middle {
		width: 15%;
		font-size: 35px;
	}

	.van-icon {
		font-size: 40px;
	}

	.down {
		transition: all .5s;
	}

	.up {
		transform: rotate(180deg);
		transition: all .5s;
	}

	.wrapper {
		position: relative;
		flex: 1;
		overflow: hidden;
	}

	.options-bar {
		
	}



	.linear-gradient {
		width: 100%;
		height: 2px;
	}


	.rectangle {
		overflow: hidden;
	}



	.rectangle .wrapper {
		position: relative;
		padding: 0 10px;
		background: #fff;
	}

	.rectangle .wrapper .content {
		position: absolute;
		display: flex;
		top: 0;
		left: 0;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	.rectangle.large .wrapper {
		padding-bottom: 100%;
	}

	.rectangle .wrapper .content .name-text.large {
		font-size: 45px;
	}

	.rectangle .wrapper .content .name-text {
		color: #7d7c7c;
		font-weight: bolder;
	}

	.rectangle .wrapper .content .odd-text.large {
		font-size: 25px;
		margin-top: -30px;
	}

	.rectangle .wrapper .content .odd-text {
		text-align: center;
		color: #ff253f;
	}

	.bottom-bar {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 100px;
		z-index: 2;
	}

	.bottom-bar .bar .left,
	.bottom-bar .bar {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.bottom-bar .bar {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 100px;
		background-color: #fff;
		box-shadow: 0 0 20px 0 #cacaca;
		z-index: 2;
	}

	.bottom-bar .bar .left,
	.bottom-bar .bar {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.bottom-bar .bar .left .item {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100px;
		font-size: 20px;
	}

	.bottom-bar .bar .left .item .text {
		font-size: 22px;
		color: #7d7c7c;
	}

	.jixuanico {
		font-size: 45px;
	}

	.bottom-bar .bar .left .line {
		width: 2px;
		height: 50px;
		background: #dadada;
	}

	.bottom-bar .bar .mid {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.bottom-bar .bar .mid .text {
		font-size: 30px;
		font-weight: 500;
		color: #000;
	}

	.bottom-bar .bar .mid .text.num {
		margin: 0 5px;
		color: #ff253f;
	}

	.bottom-bar .bar .right {
		padding: 0 30px;
		margin: 0 30px;
		color: #fff;
		background: linear-gradient(135deg, #3498db, #8e44ad);
		font-size: 40px;
		font-weight: 500;
		height: 70px;
		line-height: 70px;
		border-radius: 50px;
	}

	.rectangle.active .wrapper {
		background-color: #ff253f !important;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-popup {
		position: absolute;
	}

	::v-deep .van-overlay {
		position: absolute;
		background-color: rgb(70 67 67 / 70%);
	}

	::v-deep .van-popup--top {
		top: -1px;
	}

	.wrapper .item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 10px 0;
	}

	.wrapper .item .left {
		width: 40%;
		font-size: 30px;
		text-align: center;
		font-weight: 500;
		color: #000;
	}

	.font-weight {
		font-weight: 700 !important;
	}

	.wrapper .item .right {
		flex: 1;
		display: flex;
		font-size: 30px;
		justify-content: center;
		overflow: hidden;
		color: #000;
	}

	.wrapper .item .kuaisan-ball .left {
		justify-content: flex-start;
	}

	.wrapper .item .kuaisan-ball {
		margin-left: 20px;
		flex: 1;
		display: flex;
		align-items: center;
	}

	.wrapper .item .kuaisan-ball .res-img {
		width: 50px;
		height: 50px;
		margin-right: 20px;
	}

	.wrapper .item .kuaisan-ball .res-des {
		font-weight: 700;
		text-align: center;
		color: #000;
	}

	.wrapper .item .kuaisan-ball .res-des.middle {
		width: 15%;
		font-size: 35px;
	}

	.play-type-tip {
		position: unset;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 650px;
		height: 700px;
		max-height: 50%;
		z-index: 10;
		border-radius: 30px;
		overflow: hidden;
		background-color: #fff;
		color: #000;
	}

	.play-type-tip .title {
		line-height: 90px;
		background: linear-gradient(135deg, #3498db, #8e44ad);
		text-align: center;
		color: #fff;
		font-size: 35px;
		font-weight: 500;
	}

	.mask {
		background-color: rgb(0 0 0 / 0%);
		animation-duration: 0.35s;
	}

	.play-type-tip .wrapper {
		height: calc(100% - 10px);
		background-color: transparent;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.play-type-tip .wrapper .item {
		padding: 40px 50px;
		display: flex;
		align-items: flex-start;
	}

	.play-type-tip .wrapper .item .van-icon {
		color: #e6c3a1;
		font-size: 60px;
	}

	.play-type-tip .wrapper .item .content .content-title {
		margin-top: 22px;
		font-size: 35px;
		font-weight: 500;
		color: #000;
		line-height: 0px;
	}

	.play-type-tip .wrapper .item .content .content-detail {
		margin-top: 5px;
		font-size: 22px;
		color: #000;
		line-height: 30px;
	}

	.play-type-tip .wrapper .item .content {
		flex: 1;
		margin-left: 30px;
	}

	.rectangle.active .wrapper {
		background-color: #ff253f !important;
	}

	.rectangle.active .wrapper .name-text,
	.rectangle.active .wrapper .odd-text {
		color: #fff !important;
	}

	.bottom-bar .wrapper {
		position: absolute;
		top: 10px;
		left: 0;
		right: 0;
		padding: 20px 20px 10px 20px;
		height: 230px;
		background-color: #fff;
		z-index: 1;
		box-shadow: 0 0 10px 0 #cacaca;
		transition: transform .3s cubic-bezier(.21, 1.02, .55, 1.01);
	}

	.bottom-bar .wrapper.active {
		transform: translateY(-100%);
	}

	.bottom-bar .wrapper .item {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		height: 65px;
	}

	.bottom-bar .wrapper .item .label {
		font-size: 30px;
		line-height: 30px;
		color: #000;
	}

	.bottom-bar .wrapper .item .bet-number {
		flex: 1;
		margin: 0 16px;
		overflow: auto;
		white-space: nowrap;
		-webkit-overflow-scrolling: touch;
		color: #ff253f;
		font-size: 30px;
		font-weight: 500;
		height: 40px;
		line-height: 40px;
	}

	.bottom-bar .wrapper .item .amount-wrapper {
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.van-cell {
		font-size: 30px;
		line-height: 50px;
	}

	.bottom-bar .wrapper .item .part {
		margin-right: 20px;
	}

	.bottom-bar .wrapper .item .part span {
		font-size: 30px;
		vertical-align: center;
		color: #000;
	}

	.bottom-bar .wrapper .item .part .number {
		margin: 0 5px;
		color: #ff253f;
		font-weight: 500;
	}

	::v-deep .van-field__control {
		color: #ff253f;
	}
	
	::v-deep .van-cell::after {
		border-bottom: 1px solid #8e44ad;
	}

	.confirm-order-modal {
		position: unset;
		display: flex;
		flex-direction: column;
		margin: auto;
		padding: 0 20px 30px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 610px;
		height: 680px;
		max-height: 50%;
		z-index: 10;
		background-color: #fff;
		border-radius: 30px;
	}

	.confirm-order-modal .head {
		position: relative;
		height: 80px;
	}

	.confirm-order-modal .head .text {
		padding: 0 20px;
		height: 30px;
		line-height: 10px;
		text-align: center;
		font-size: 35px;
		font-weight: 500;
		color: #7e5678;
	}

	::v-deep .confirm-order-modal .van-hairline--bottom::after {
		border-bottom-width: 2px;
	}

	.van-popup--center {
		border-radius: 30px;
	}

	.confirm-order-modal .list {
		flex: 1;
		padding: 0 10px;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.confirm-order-modal .list .lise-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 10px 0;
	}

	.confirm-order-modal .list .lise-item .main {
		flex: 1;
		overflow: hidden;
	}

	.confirm-order-modal .list .lise-item .main .bet-name {
		color: #ff253f;
		font-size: 35px;
		font-weight: 500;
		line-height: 0px;
		word-wrap: break-word;
		word-break: break-all;
	}

	.confirm-order-modal .list .lise-item .main .detail-text {
		line-height: 0px;
		font-size: 25px;
		color: #979799;
	}

	.confirm-order-modal .list .lise-item {
		color: #ff253f;
	}

	.confirm-order-modal .sub-bar {
		display: flex;
		align-items: center;
		margin-top: 30px;
		justify-content: space-around;
	}

	.confirm-order-modal .sub-bar .item {
		min-width: 40%;
		height: 80px;
		text-align: center;
		box-sizing: border-box;
		border-radius: 50px;
		font-size: 35px;
		font-weight: 500;
	}

	.confirm-order-modal .sub-bar .item.cancel-btn {
		border: 2px solid #979799;
		color: #979799;
		background-color: #fff;
	}

	.confirm-order-modal .sub-bar .item.sub-btn {
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
		color: #fff;
		border: 0;
	}

	.next-number span {
		font-size: 35px;
		font-weight: 700;
		color: #000;
		float: right;
	}

	.lottery {
		background: url(/img/room_bg-Ddn4imz_.gif) no-repeat;
		background-size: 94% auto;
		background-position: center 20px;
	}

	.bix {
		padding: 20px;
		/* height:80vh; */
		/* overflow-y: scroll; */
		color: #fff;
	}

	.record {
		padding: 20px;
	}

	.info_c_h {
		display: flex;
		flex-direction: column;
		justify-content: start;
		align-items: flex-start;
		color: #fff;
		padding: 5px 0px 20px;
	}

	.info_c_b {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 0;
	}

	.options-bar {
		border: 1px solid #fff;
		border-radius: 2.66667vw;
		background: linear-gradient(135deg, #fff, #f8f9fa);

	}

	.put_tit_r {
		font-weight: 700;
		color: #34196a;
		font-size: 3.73333vw;
		padding-left: 2.13333vw;
		position: relative;
		margin: 2.66667vw;
	}

	.put_tit_r:before {
		content: "";
		display: block;
		position: absolute;
		width: 1.06667vw;
		height: 4vw;
		background: linear-gradient(90deg, #ff7a8d 0, #ff4d67);
		left: 0;
		top: .8vw;
	}

	.game {
		height: 100%;
		overflow-y: auto;
	}

	.sumValueTwoSides {
		display: grid;
		grid-template-columns: repeat(2,1fr);
		gap: 16px;
		padding: 10px;
	}

	.bix .options-bar .large {
		text-align: center;
		background: #fff;
		box-shadow: 2px 2px 2px 2px #0000001a;
		border-radius: 20px;
		color: #fff;
	}

	.sumValueTwoSides .c_u_item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid transparent;
	}
	.c_u_item img{
			width: 80px;
	}

	

	.bix .options-bar .active {
		position: relative;
	}

	.bix .options-bar .active .c_u_item {
		background: #212121 !important;
		color: #f3c7a2 !important;
		box-sizing: border-box;
		border: 1px solid #fff;
	}

	.bix .options-bar .active:after {
		content: "";
		background: url(data:image/png;base64,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) 100% 100% no-repeat;
		background-size: 60px auto;
		width: 60px;
		height: 60px;
		position: absolute;
		bottom: 1px;
		right: 1px;
		display: block;
	}
	.text_ks{
		padding-right: 15px;
	}
</style>